export class Payer{
    name:string;
    lastName:string;
    email:string;
    reEmail:string;
    country:any = {};

    constructor(){
        this.country = {id: -1}; // By default
    }
}